import { IAgentSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { prepareAgentExperience } from './prepareAgentExperience';

export function getAgentMarketExperience({ experience }: IAgentSchema) {
  const preparedExperience = prepareAgentExperience(experience);

  return preparedExperience ? `На рынке ${preparedExperience}` : null;
}
